/**
 * classe che esegue azione finchè non restiuisce true
 */
export class UntillDone {
  protected action: () => boolean;

  protected timeout: any;

  protected interval: number;

  constructor(action: () => boolean, options: { interval?: number } = {}) {
    if (typeof action === 'function') {
      this.action = action;
    } else {
      this.action = () => true;
    }

    this.interval = options.interval || 500;
  }

  do(): void {
    this.clearRetry();

    const done = this.action();

    if (done) {
      return;
    }

    this.scheduleRetry();
  }

  protected scheduleRetry(): void {
    this.timeout = setTimeout(() => {
      this.do();
    }, this.interval);
  }

  protected clearRetry(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  }
}
